export function brokerageDisclosuretoSellerFSBO2027() {
return [   // Release 2026-10-06 16:03:27
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 1,
   name: "Property description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 372.24,
   left: 57.6,
   width: 495.12,
   height: 35.171
}
,
{
   page: 1,
   name: "Checkbox Multiple Person Firm", 
   isText: false,
   type: "checkbox",
   top: 465.384,
   left: 57.6003,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox One Person Firm", 
   isText: false,
   type: "checkbox",
   top: 521.675,
   left: 57.6003,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Customer", 
   isText: false,
   type: "checkbox",
   top: 568.148,
   left: 56.9457,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Customer Broker is buyers agent", 
   isText: false,
   type: "checkbox",
   top: 568.148,
   left: 187.855,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Customer buyers transaction broker and seller is customer", 
   isText: false,
   type: "checkbox",
   top: 567.493,
   left: 260.51,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Show a property", 
   isText: false,
   type: "checkbox",
   top: 580.584,
   left: 200.946,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Prepare and convey written offers", 
   isText: false,
   type: "checkbox",
   top: 581.239,
   left: 283.419,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Transaction Brokerage only", 
   isText: false,
   type: "checkbox",
   top: 614.621,
   left: 58.2548,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 2,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 295.865,
   left: 66.9019,
   width: 94.6141,
   height: 13.036
}
,
{
   page: 2,
   name: "Client Names Legal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 319.338,
   left: 116.035,
   width: 418.256,
   height: 13.036
}
,
{
   page: 2,
   name: "via", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 342.432,
   left: 141.073,
   width: 247.921,
   height: 13.036
}
,
{
   page: 2,
   name: "Signature Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 407.673,
   left: 46.9054,
   width: 287.1506,
   height: 13.036
}
,
{
   page: 2,
   name: "Agent Brokerage Manager Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 364.487,
   left: 205.175,
   width: 359.674,
   height: 13.036
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 386.509,
   left: 154.033,
   width: 401.009,
   height: 13.036
}
] }
